import React, {Component} from 'react';
import {withRouter} from 'react-router';

import {Alert} from 'reactstrap';
import {Redirect} from "react-router-dom";


import PreAdmissionForm from "../../components/pre-admission-form/PreAdmissionForm";
import BackendApiService from '../../services/BackendApiService'

class PreAdmissionEdition extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMessageVisible: false,
            preAdmission:{},
            loadingPreAdmission: true,
            loaded: false,
            message:'',
            redirect: false
        };

        this.showSuccesMessage       = this.showSuccesMessage.bind(this);
        this.showErrorMessage        = this.showErrorMessage.bind(this);
        this.onDismiss               = this.onDismiss.bind(this);
        this.updatePreAdmission               = this.updatePreAdmission.bind(this);
    }
    onDismiss() {
        this.setState({ isMessageVisible: false });
    }

    componentDidMount(){
        const id = this.props.match.params.id;
        BackendApiService.getPreAdmissionData(id).then(data=>{
            this.setState({preAdmission:data, loaded:true,loadingPreAdmission:false})
        }).catch(error=>{
            this.setState({loaded:false,loadingPreAdmission:false})
            this.showErrorMessage("No ha sido cargado el preingreso")
        })
    }

    showSuccesMessage(message) {
        this.setState({
            message: {
                success: true,
                text: message
            }, isMessageVisible: true
        })
    }

    showErrorMessage(message) {
        this.setState({
            message: {
                success: false,
                text: message
            }, isMessageVisible: true
        })
    }
    async updatePreAdmission(data){
        console.log("registrando preadmision")
        const id = this.props.match.params.id;

        console.log(data);

        const dataKeyMap = {
            plate: 'patente',
            agreementPrice: 'precio_convenio',
            proprietaryRUT: 'propietario_rut',
            proprietaryQuality: 'propietario_calidad',
            proprietaryCommunity: 'propietario_comuneros',
            acquirerRUT: 'adquiriente_rut',
            acquirerQuality: 'adquiriente_calidad',
            acquirerCommunity: 'adquiriente_comuneros',
            addressStreet: 'calle',
            addressNumber: 'calle_numero',
            addressRest: 'adquiriente_resto_domicilio',
            addressCommunity: 'comuna_codigo',
            addressTelephone: 'telefono',
            documentNumber: 'documento_numero',
            documentDate: 'documento_fecha'
        }
        let dataMap = {};
        for(let key in data){
            if(dataKeyMap.hasOwnProperty(key)){
                dataMap[dataKeyMap[key]] = data[key];
            }
        }
        dataMap['transferencia_idtransferencia'] = this.state.preAdmission.transferencia_idtransferencia;
        try{
            const response = await BackendApiService.updatePreAdmision(id, dataMap)
            if(response === false){
                this.showErrorMessage("Ocurrio un error al registrar el preingreso");
            }else{
                this.showSuccesMessage("Preingreso guardado con éxito");
                this.setState({redirect: true})
            }

        }catch (e){
            this.showErrorMessage("Ocurrio un error al registrar el preingreso");
        }

    }
    render() {
        if(this.state.redirect){
            return <Redirect to='/preingresos' />
        }else{
            return (<div className="main-wrapper-page">
                <h2 className="page-title">Editar preingreso</h2>
                {this.state.isMessageVisible && <Alert className="mt-2" color={this.state.message.success?'success':'danger'} isOpen={this.state.isMessageVisible} toggle={this.onDismiss}>
                    {this.state.message.text}
                </Alert>
                }
                {this.state.loadingPreAdmission ? 'Cargando' : ''}

                {this.state.loaded && <PreAdmissionForm
                    saveHandler={this.updatePreAdmission}
                    preAdmission={this.state.preAdmission}
                    saveText="Actualizar"
                />}
            </div>);
        }

    }
}

export default withRouter(PreAdmissionEdition);
